import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)
const AsyncHome = () => import('../views/Home.vue')

const routes = [{
    path: '/',
    name: 'Home',
    component: AsyncHome,
    children: [{
        path: '/',
        component: () => import('../components/MainPageComponents.vue')
      }, {
        path: 'kontakt',
        component: () => import('../components/Contact.vue')
      },
    ],
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/Error.vue')
  }, {
    path: '/pending',
    name: 'Pending',
    component: () => import('../views/Pending.vue')
  },
  {
    path: '/thankyou',
    name: 'ThankYou',
    component: () => import('../views/ThankYou.vue')
  },
  {
    path: '/thankyou_single',
    name: 'ThankYou',
    component: () => import('../views/ThankYouSingle.vue')
  },
  {
    path: '/prywatnosc',
    component: () => import('../components/Privacy.vue')
  },
  {
    path: '/json',
    name: 'json',
    component: () => import('../views/Json.vue')
  },
  {
    path: '*',
    component: () => import('../views/PageNotFound.vue')
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

export default router